import get from 'lodash.get';

/**
 * Boolean function to check to see if we are on an MSNBC daily opinion page. This triggers
 * additional styles to show indicate that this page is opinion, not news.
 *
 * @returns {Boolean}
 */
export const isMSNBCDaily = (vertical, taxonomy) => {
  const primarySectionName = get(taxonomy, ['primarySection', 'name'], '');
  const primaryTopicName = get(taxonomy, ['primaryTopic', 'name'], '');

  return vertical === 'msnbc' && primarySectionName === 'Opinion' && primaryTopicName === 'Opinion';
};

/**
 * Normalizer function to aid in extracting the sections from an article. External links are missing
 * the description and external link. This function returns a more consistent Article Body array.
 */
export const getNormalizedArticleBody = (article) => {
  const { subType = '', body = [] } = article;

  if (subType === 'externalLink') {
    const { description, url } = article;
    // Store the body data in format getSections expects.
    return [
      // Description as first paragraph.
      {
        type: 'markup',
        element: 'p',
        html: description.primary || description.social,
      },
      // The external link.
      {
        type: subType,
        url: url.primary,
      },
    ];
  }

  // Default
  return body;
};
